module.exports = __webpack_public_path__ + "static/media/logo-texto-topo.f241c934.png";